import React from 'react';
import PropTypes from 'prop-types';
import {createUltimatePagination} from 'react-ultimate-pagination';
import {Button} from '@material-ui/core';
import {FirstPage as FirstPageIcon, LastPage as LastPageIcon, MoreHoriz as MoreHorizIcon} from '@material-ui/icons';
import withStyles from '@material-ui/core/styles/withStyles';

const withButtonStyles = withStyles({
  root: {
    minWidth: 32,
  },
});

const Page = withButtonStyles(({value, isActive, isDisabled, onClick, classes}) => (
  <Button color={isActive ? 'primary' : 'default'} disabled={isDisabled} onClick={onClick} className={classes.root}>
    {value}
  </Button>
));

const Ellipsis = withButtonStyles(({isDisabled, onClick, classes}) => (
  <Button disabled={isDisabled} onClick={onClick} className={classes.root}>
    <MoreHorizIcon />
  </Button>
));

const FirstPageLink = withButtonStyles(({isDisabled, onClick, classes}) => (
  <Button disabled={isDisabled} onClick={onClick} className={classes.root}>
    <FirstPageIcon />
  </Button>
));

const LastPageLink = withButtonStyles(({isDisabled, onClick, classes}) => (
  <Button disabled={isDisabled} onClick={onClick} className={classes.root}>
    <LastPageIcon />
  </Button>
));

const Wrapper = (props) => <div className="pagination">{props.children}</div>;

const Pager = ({currentPage, totalPages, onChange}) =>
  React.createElement(
    createUltimatePagination({
      itemTypeToComponent: {
        PAGE: Page,
        ELLIPSIS: Ellipsis,
        FIRST_PAGE_LINK: FirstPageLink,
        LAST_PAGE_LINK: LastPageLink,
      },
      WrapperComponent: Wrapper,
    }),
    {
      currentPage,
      totalPages,
      hidePreviousAndNextPageLinks: true,
      onChange,
    },
  );

Pager.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Pager;
